<template>
  <div>
    <modal
      :show.sync="isActiveLocal"
      size="md"
      centered
      header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
      modal-content-classes="cust-modal-ht-wo-tools"
      footer-hide
      class="overflow-y-hidden"
    >
      <div class="flex justify-between">
        <div class="flex">
          <div class="my-auto">
            <p class="tools-popup-txt">
              {{ selectedTools.title }}
            </p>
            <p class="pt-2 tools-popup-desc">
              {{
                selectedTools.desc ||
                "Please fill in the details below to download the resource"
              }}
            </p>
          </div>
        </div>
        <img
          src="../../../../assets/images/cross.png"
          class="h-8 w-8 cursor-pointer"
          alt="cross"
          @click="isActiveLocal = false"
        />
      </div>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleSend)">
          <div
            class="py-8 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-3 gap-5"
          >
            <div class="">
              <p class="input-title-impact-popup">Name</p>
              <base-input
                v-model="name"
                placeholder="Enter your name"
                class="formmb"
                name="Name"
                :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
                @input="
                  name = name
                    .replace(/[^A-Za-z\s]/g, '')
                    .replace(/\s{2,}/g, ' ')
                "
              ></base-input>
            </div>
            <div class="">
              <p class="input-title-impact-popup">Email Address</p>
              <base-input
                v-model="email"
                placeholder="Enter your EmailID"
                class="formmb"
                name="Email"
                :rules="{ required: true, email: true }"
              ></base-input>
            </div>
            <div class="formmb">
              <p class="input-title-impact-popup">Mobile No.</p>
              <base-input
                v-model="mobile"
                placeholder="Enter your Mobile No."
                class="formmb"
                name="Mobile No."
                :rules="{ required: true, regex: /^[0-9]{10}$/ }"
                @input="mobile = mobile.replace(/\D/g, '').slice(0, 10)"
              ></base-input>
            </div>
            <div class="formmb">
              <p class="input-title-impact-popup">Designation</p>
              <base-input
                v-model="designation"
                placeholder="Enter your Designation"
                class="formmb"
                name="Designation"
                :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
                @input="
                  designation = designation
                    .replace(/[^A-Za-z\s]/g, '')
                    .replace(/\s{2,}/g, ' ')
                "
              ></base-input>
            </div>
            <div class="formmb">
              <p class="input-title-impact-popup">Organisation</p>
              <base-input
                v-model="company"
                placeholder="Enter your Organisation Name"
                class="formmb"
                name="Company Name"
                :rules="{ required: true }"
              ></base-input>
            </div>
          </div>
          <div class="flex justify-center">
            <b-button
              type="submit"
              variant="primary"
              filled
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700"
              >Submit</b-button
            >
          </div>
        </b-form>
      </validation-observer>
      <!-- <div v-html="selectedTools.html"></div> -->
      <template slot="footer">
        <div>
          <!-- <img src="@/assets/images/customer-view/cs.jpg" class="w-full screenht" /> -->
        </div>
      </template>
    </modal>
    <div></div>
  </div>
</template>

<script>
import PDFviewer from "./PDFviewer.vue";
import emailMixin from "@/mixins/email";
import axios from "axios";
import fetch from "node-fetch";
import { Header } from "element-ui";
import { mapState } from "vuex";

export default {
  components: {
    PDFviewer,
  },

  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.name = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = this.user.mobile;
      this.designation = this.user["designtion"] ? this.user["designtion"] : "";
      this.company = this.user["companyName"] ? this.user["companyName"] : "";
    }
  },
  mixins: [emailMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedTools: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data: {},
      name: "",
      email: "",
      designation: "",
      company: "",
      mobile: "",
      message: "",
    };
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

    async handleSend() {
      try {
        let payload = {
          name: this.name,
          email: this.email,
          mobile: this.mobile,
          designation: this.designation,
          organization: this.company,
          selfHelpTool: this.data.title,
        };
        await this.$store.dispatch("cms/selfHelpViewers", payload);
      } catch (error) {
        console.log(error);
      }
      this.closeModal();
      this.data = this.selectedTools;
      const to = ["services@caregiversaathi.co.in"];
      const cc = [];
      const bcc = [
        // "yash.singh@aiab.in",
        "bhavana.issar@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];

      const subject = `Self-help Tools -  ${this.data.title}`;
      const message = `
      The following user downloaded the content. <br />
      Name: ${this.name}<br />
      Email Address: ${this.email}<br />
      Designation: ${this.designation}<br />
      Organisation: ${this.company}<br />
      Mobile No.: ${this.mobile}<br />

      `;
      await this.sendEmail(to, subject, message, cc, bcc);

      if (this.data.paytype !== "Free") {
        this.data.file && this.data.file != "null"
          ? this.downloadFile(this.$imageURL + "/" + this.data.file)
          : this.$swal.fire({
              text: "No file found!!",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
      } else {
        // console.log(this.data);
        this.$store.commit("cms/SELECTED_PDF", this.data);
        let link = this.$router.resolve({ name: "pdfviewer" });
        window.open(link.href, "_blank");
      }
      this.$refs.formValidator.reset();
    },
    xyz() {
      return this.$imageURL + "/" + this.selectedTools.file;
    },
    downloadFile(source) {
      // window.open(this.$imageURL + "/" + this.selectedTools.file, "_blank");
      // var link = document.createElement("a");
      // link.setAttribute("Download", name);
      // link.href = this.$imageURL + "/" + this.selectedTools.file;
      // document.body.appendChild(link);
      // , {
      //   method: "GET",
      //   responseType: "blob",
      // }
      // fetch.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      // const myHeaders = new Header();
      // myHeaders.append();
      // fetch(this.$imageURL + "/" + this.selectedTools.file, {
      //   mode: "cors",
      //   headers: { "Access-Control-Allow-Origin": "*" },
      // }).then((res) => {
      //   // var FILE = window.URL.createObjectURL(new Blob([res.data]));
      //   // var docUrl = document.createElement("x");
      //   // docUrl.href = FILE;
      //   // docUrl.setAttribute("download", this.selectedTools.file);
      //   // document.body.appendChild(docUrl);
      //   // docUrl.click();
      //   console.log(res);
      // });
      var el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", "file");
      document.body.appendChild(el);
      el.click();
      el.remove();
    },
  },
};
</script>
<style>
.formmb .form-group {
  margin-bottom: 0px !important;
}
</style>
